import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../utils/Utils";

/**
 * ProtectedRoute component to wrap protected routes
 * Checks if token exists in localStorage before allowing access
 * Redirects to login if token is missing
 */
const ProtectedRoute = ({ children }) => {
  const token = getToken();

  if (!token) {
    return <Navigate to="/auth-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
